// export { default as join } from "./join/join.vue";
export const invitationJoin = (r) => require.ensure([], () => r(require("./join/join.vue")), "invitationJoin");
export const invitationNew = (r) => require.ensure([], () => r(require("./new/new.vue")), "invitationNew");
